import type { PapelObra, PapelObraMarco } from "./papeis-obra.types";

export const JANELA_NAO_OBRIGATORIO = "—";

function dias(n: number): string {
  return n === 1 ? "1 dia" : `${n} dias`;
}

function isDias(value: number | null | undefined): value is number {
  return typeof value === "number" && Number.isFinite(value);
}

/** Descrição do deslocamento em relação ao marco; na saída a frase abre com "Sai". */
function formatMarco(marco: PapelObraMarco, n: number, saida: boolean): string {
  const prefix = saida ? "Sai " : "";
  switch (marco) {
    case "ANTES_INICIO_OBRA":
      return `${saida ? "Sai até" : "Até"} ${dias(n)} antes do início da obra (D-${n})`;
    case "DEPOIS_INICIO_OBRA":
      return `${prefix}${dias(n)} após o início da obra (D+${n})`;
    case "ANTES_TERMINO_OBRA":
      return `${prefix}${dias(n)} antes do término da obra (T-${n})`;
    case "DEPOIS_TERMINO_OBRA":
      return `${prefix}${dias(n)} após o término da obra (T+${n})`;
  }
}

function formatEntrada(janela: NonNullable<PapelObra["janela"]>): string | null {
  const { inicioDaObra, dias: n, marco } = janela.entrada;
  if (inicioDaObra) return "Entra no início da obra";
  if (!isDias(n) || !marco) return null;

  return formatMarco(marco, n, false);
}

function formatSaida(janela: NonNullable<PapelObra["janela"]>): string | null {
  const { terminoDaObra, dias: n, marco } = janela.saida;
  if (terminoDaObra) return "Sai no término da obra";
  if (!isDias(n) || !marco) return null;

  return formatMarco(marco, n, true);
}

/** Texto da coluna "Janela de alocação", composto a partir da janela do papel. */
export function formatPapelObraJanela(papel: Pick<PapelObra, "obrigatorio" | "janela">): string {
  if (!papel.obrigatorio || !papel.janela) return JANELA_NAO_OBRIGATORIO;

  const parts = [formatEntrada(papel.janela), formatSaida(papel.janela)].filter(
    (part): part is string => part !== null,
  );

  return parts.length > 0 ? parts.join(" · ") : JANELA_NAO_OBRIGATORIO;
}
